import { Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import CommonImage from '@components/CommonImage';

import { isAllowEdit } from '@features/supplier/utils';
import ConfirmationModal from '@features/crm/components/ConfirmationModal';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { getSupplierDocuments, removeSupplierDocuments } from '@services/supplierOnboardingService';

import { changeDateFormat, getFileType, getIconByFileType, getShortName, printApiError } from '@utils/Util';

const GetTypeWiseDocuments = ({ documents, title, fieldName, onViewClick, isShowRemove = true }) => {
	const dispatch = useDispatch();
	const { id } = useParams();
	const [isShowConfirmation, setIsShowConfirmation] = useState(false);
	const [selectedId, setSelectedId] = useState(null);

	const onRemoveDocument = async (docId) => {
		try {
			dispatch(openLoader());
			await removeSupplierDocuments(id, docId);
			await dispatch(getSupplierDocuments(id));
			dispatch(closeLoader());
		} catch (e) {
			dispatch(closeLoader());
			printApiError(e);
		}
	};

	const renderTypeWiseDocuments = () => {
		const documentList = documents[fieldName] || [];

		if (documentList.length > 0) {
			return (
				<div
					className="single text-left same-padding-box d-flex flex-column justify-content-center"
					onClick={() => {
						if (onViewClick) {
							onViewClick();
						}
					}}
				>
					<p className="gray_dark_01 weight-700 regular-14">{title}</p>

					{documentList?.map((item) => {
						let fileType;
						if (item.docUrl) {
							fileType = getFileType(item.docUrl);
						} else {
							fileType = getFileType(item.name);
						}
						return (
							<div
								key={`document_${item.id}`}
								className="addition-info align-items-center pt-1 cursor-pointer"
							>
								{item?.rank && (
									<p className="regular-14 gray_dark_01 pb-2">
										Rank:
										{item.rank}
									</p>
								)}
								{item?.auditDate && (
									<p className="regular-14 gray_dark_02 pb-2">
										Audited on&nbsp;
										{changeDateFormat(item.auditDate, '', 'DD MMM, YYYY')}
									</p>
								)}
								{item?.expiryDate && (
									<p className="regular-14 gray_dark_02 pb-2">
										Expiry Date&nbsp;
										{changeDateFormat(item.expiryDate, '', 'DD MMM, YYYY')}
									</p>
								)}
								<div className="d-flex align-items-center">
									<img
										src={getIconByFileType(fileType)}
										width={19}
										alt=""
										onClick={() =>
											window.open(
												item?.docUrl || item?.documentResponse?.docUrl,
												'_blank'
											)
										}
									/>
									<div>
										<Tooltip
											title={item?.name || item?.documentResponse?.name}
											placement="top"
											arrow
										>
											<p
												className="regular-12 pl-1"
												onClick={() => window.open(item.docUrl, '_blank')}
											>
												{getShortName(item.name || item?.documentResponse?.name, 20)}
											</p>
										</Tooltip>
									</div>
									{isShowRemove && isAllowEdit() && (
										<div
											className="remove-icon cursor-pointer ml-1"
											onClick={() => {
												setSelectedId(item?.id || item?.documentResponse?.id);
												setIsShowConfirmation(true);
											}}
										>
											<CommonImage src="/icons/trash.svg" alt="" width={18} />
										</div>
									)}
								</div>
							</div>
						);
					})}
				</div>
			);
		}
	};

	return (
		<>
			{renderTypeWiseDocuments()}
			{isShowConfirmation && (
				<ConfirmationModal
					title="Comfirmation"
					description="you want to remove this document?"
					closeModal={() => setIsShowConfirmation(false)}
					callback={async () => {
						await onRemoveDocument(selectedId);
						setIsShowConfirmation(false);
					}}
				/>
			)}
		</>
	);
};

export default GetTypeWiseDocuments;
